import React, { FunctionComponent } from "react";
import NextLink from "@adjust/website/src/components/NextLink";
import { Nav, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/free-solid-svg-icons";

type NavCanvasProps = {
  name: string;
  icon: IconDefinition;
  href: string;
};

const NavCanvasLinkComponent: FunctionComponent<NavCanvasProps> = ({ href, name, icon }) => {
  return (
    <Col xs={4} className="my-3">
      <NextLink href={href}>
        <Nav.Link className="p-0 text-center text-muted">
          <FontAwesomeIcon icon={icon} size="lg" />
          <div>{name}</div>
        </Nav.Link>
      </NextLink>
    </Col>
  );
};

export default React.memo(NavCanvasLinkComponent);
